module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "christy-porter-black.3f9d29fe.png";